/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
class CasinoReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uid: "",
      passcode: ""
    };
  }
  onChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value })
  }
  render() {
    return (
      <body className="bethubs">
        <Header history = {this.props.history} />
        <div className="wrapper">
          <div className="w3-sidebar w3-bar-block w3-border-right" style={{ "display": "none" }} id="mySidebar">
            <button onclick="w3_close()" className="w3-bar-item w3-large bg-hover">Close &times;</button>
            <ul>
              <li><a href="list-of-clients.html">List of Clients</a></li>
              <li><a href="#">Market Analysis</a></li>
              <li><a href="import-event.html">Import Event</a></li>
              <li>
                <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Live Markets </a>
                <ul className="list-unstyled collapse" id="homeSubmenu" >
                  <li><a href="#">Test 1</a></li>
                </ul>
              </li>
              <li>
                <a href="#home1Submenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Reports</a>
                <ul className="list-unstyled collapse" id="home1Submenu" >
                  <li><a href="#">Test 1</a></li>
                  <li><a href="#">Test 1</a></li>
                </ul>
              </li>
            </ul>
          </div>
          <div className="container-fluid container-padding-0">
            <div className="row">
               <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="main-box">
                  <span className="text-red ">This is only Layout Design of Page.</span>
                    <br /><br />
                     <h5 className="text-blue">Casino Report</h5>
                     <div className="row">
                        <div className="col-md-2">
                            <div className="form-group font-12">
                              <span className="d-inline-block text-black">From</span>
                              <input className="form-control d-inline-block" type="date" id="FromDate" />
                           </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group font-12">
                              <span className="d-inline-block text-black">To</span>
                              <input className="form-control d-inline-block" type="date" id="FromDate" />
                           </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group font-12">
                              <span className="d-inline-block text-black">Game Type</span>
                              <select className="form-control" id="exampleFormControlSelect1">
                                 <option>Slot Game</option>
                                 <option>Live Casino</option>
                                 <option>Live Casino 1</option>
                              </select>
                           </div>
                        </div>
                        <div className="col-md-2">
                           <div className="float-left">
                              <button className="btn btn-blue accbtn mar-top-20">Submit</button>
                           </div>
                        </div>
                     </div>
                     <div className="table-responsive">
                        <table id="basic-btn" className="table table-striped table-bordered font-12 table-sm">
                           <thead>
                              <tr className="bg-dark text-white">
                                 <th>User Name</th>
                                 <th>Casino Type</th>
                                 <th>Game Name</th>
                                 <th>Transaction Id</th>
                                 <th>Transaction Type</th>
                                 <th>Game Id</th>
                                 <th>Amount</th>
                                 <th>Date</th>
                              </tr>
                           </thead>
                           <tbody>
                            <tr>
                                 <td colspan="8" className="text-center">No Data Available in Table</td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
               </div>
            </div>
         </div>        
        </div>
        <Footer />
      </body>

    )
  }
}
function mapStateToProps(state) {
  return {
  };
}
function mapDispatchToProps(dispatch) {
  return {
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CasinoReports);